var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandardPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient10);\n        filter: url(#drop-shadow-1);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient21);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient9);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient18);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient16);\n      }\n\n      .st8 {\n        isolation: isolate;\n      }\n\n      .st9 {\n        fill: url(#linear-gradient19);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient12);\n      }\n\n      .st11 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st12 {\n        fill: url(#linear-gradient20);\n      }\n\n      .st13 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st14 {\n        fill: url(#linear-gradient14);\n      }\n\n      .st15 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st16 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st17 {\n        fill: url(#linear-gradient15);\n      }\n\n      .st18 {\n        fill: url(#linear-gradient17);\n      }\n\n      .st19 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st20 {\n        fill: url(#linear-gradient13);\n      }\n\n      .st21 {\n        fill: url(#linear-gradient);\n      }\n\n      .st22 {\n        fill: url(#linear-gradient11);\n        mix-blend-mode: screen;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 50,
    y1: 94.44,
    x2: 50,
    y2: 42.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6ddf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3005f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 50,
    y1: 69.87,
    x2: 50,
    y2: 104.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff6ddf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3005f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 31.26,
    y1: 90.11,
    x2: 31.26,
    y2: 42.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 68.74,
    y1: 90.11,
    x2: 68.74,
    y2: 42.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 21.06,
    y1: 10.16,
    x2: 21.06,
    y2: 58.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 78.94,
    y1: 10.16,
    x2: 78.94,
    y2: 58.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 26.36,
    y1: 20.19,
    x2: 26.36,
    y2: 68.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 73.64,
    y1: 20.19,
    x2: 73.64,
    y2: 68.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 90.55,
    y1: 42.46,
    x2: -43.51,
    y2: 42.46,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 74.6,
    y1: 8.46,
    x2: 21.8,
    y2: 81.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 50,
    y1: 11.03,
    x2: 50,
    y2: 73.89,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    x: 21.6,
    y: 11.03,
    width: 56.8,
    height: 62.86,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: 50,
    y1: 15.26,
    x2: 50,
    y2: 69.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3900d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: 50,
    y1: 32.43,
    x2: 50,
    y2: 64.82,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: 38.86,
    y1: 42.46,
    x2: 61.14,
    y2: 42.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: 44.89,
    y1: 30.65,
    x2: 44.89,
    y2: 42.46,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient15",
    x1: 55.11,
    y1: 42.46,
    x2: 55.11,
    y2: 30.65,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient16",
    x1: 50,
    y1: 42.46,
    x2: 50,
    y2: 42.46,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient17",
    x1: 55.11,
    y1: 48.36,
    x2: 55.11,
    y2: 36.55,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient18",
    x1: 55.11,
    y1: 54.27,
    x2: 55.11,
    y2: 42.46,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient19",
    x1: 44.89,
    y1: 42.46,
    x2: 44.89,
    y2: 54.27,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient20",
    x1: 44.89,
    y1: 48.36,
    x2: 44.89,
    y2: 36.55,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient21",
    x1: 50,
    y1: 34.69,
    x2: 50,
    y2: 50.23,
    xlinkHref: "#linear-gradient1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "35.84 42.46 35.84 86.26 50 94.44 64.16 86.26 64.16 42.46 35.84 42.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "37.95 85.04 37.95 44.58 62.05 44.58 62.05 85.04 50 91.99 37.95 85.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "28.8 82.2 33.72 85.04 33.72 42.46 28.8 42.46 28.8 82.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.28 42.46 66.28 85.04 71.2 82.2 71.2 42.46 66.28 42.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M5.21,38.1l35.45,20.46v-25.78L1.47,10.16v21.46c0,2.67,1.43,5.14,3.74,6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M59.35,32.79v25.78l35.45-20.46c2.31-1.34,3.74-3.81,3.74-6.48V10.16l-39.19,22.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M10.5,48.13l35.45,20.46v-25.78L6.76,20.19v21.46c0,2.67,1.43,5.14,3.74,6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M54.05,42.81v25.78l35.45-20.46c2.31-1.34,3.74-3.81,3.74-6.48v-21.46l-39.19,22.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M83.7,53.76v-22.61c0-5.04-2.69-9.7-7.06-12.23l-19.58-11.3c-4.37-2.52-9.75-2.52-14.12,0l-19.58,11.3c-4.37,2.52-7.06,7.18-7.06,12.23v22.61c0,5.04,2.69,9.7,7.06,12.23l19.58,11.3c4.37,2.52,9.75,2.52,14.12,0l19.58-11.3c4.37-2.52,7.06-7.18,7.06-12.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50,79.35c-2.47,0-4.94-.64-7.15-1.91l-19.58-11.3c-4.41-2.55-7.15-7.29-7.15-12.38v-22.61c0-5.09,2.74-9.83,7.15-12.38l19.58-11.3c4.41-2.55,9.89-2.55,14.29,0l19.58,11.3c4.41,2.55,7.15,7.29,7.15,12.38v22.61c0,5.09-2.74,9.83-7.15,12.38l-19.58,11.3c-2.2,1.27-4.68,1.91-7.15,1.91ZM50,5.92c-2.41,0-4.82.62-6.97,1.86l-19.58,11.3c-4.3,2.48-6.97,7.11-6.97,12.07v22.61c0,4.96,2.67,9.59,6.97,12.07l19.58,11.3c4.3,2.48,9.64,2.48,13.94,0l19.58-11.3c4.3-2.48,6.97-7.11,6.97-12.07v-22.61c0-4.96-2.67-9.59-6.97-12.07l-19.58-11.3c-2.15-1.24-4.56-1.86-6.97-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,73.89c-1.55,0-3.07-.41-4.41-1.18l-19.58-11.3c-2.72-1.57-4.41-4.5-4.41-7.64v-22.61c0-3.14,1.69-6.07,4.41-7.64l19.58-11.3c1.34-.77,2.87-1.18,4.41-1.18s3.07.41,4.41,1.18l19.58,11.3c2.72,1.57,4.41,4.5,4.41,7.64v22.61c0,3.14-1.69,6.07-4.41,7.64l-19.58,11.3c-1.34.77-2.86,1.18-4.41,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M50,69.65c-.8,0-1.6-.21-2.29-.61l-19.58-11.3c-1.42-.82-2.29-2.34-2.29-3.97v-22.61c0-1.63.88-3.16,2.29-3.97l19.58-11.3c.7-.4,1.49-.61,2.29-.61s1.6.21,2.29.61l19.58,11.3c1.42.82,2.29,2.34,2.29,3.97v22.61c0,1.63-.88,3.16-2.29,3.97l-19.58,11.3c-.7.4-1.49.61-2.29.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "37.13 49.89 37.13 35.03 50 27.59 62.87 35.03 62.87 49.89 50 57.32 37.13 49.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "38.86 48.89 38.86 36.03 50 29.59 61.14 36.02 61.14 48.89 50 55.32 38.86 48.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "50 30.65 50 30.65 39.77 36.55 50 42.46 50 30.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "50 42.46 60.23 36.55 60.23 36.55 50 30.65 50 42.46 50 42.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "50 42.46 50 42.46 50 42.46 50 42.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "50 42.46 60.23 48.36 60.23 36.55 50 42.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "50 42.46 50 54.27 50 54.27 60.23 48.36 60.23 48.36 50 42.46 50 42.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "39.77 48.36 39.77 48.36 50 54.27 50 42.46 39.77 48.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "50 42.46 39.77 36.55 39.77 36.55 39.77 48.36 50 42.46 50 42.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "50 34.69 50 34.69 43.27 38.57 43.27 38.57 43.27 46.34 43.27 46.34 50 50.23 50 50.23 56.73 46.34 56.73 46.34 56.73 38.57 56.73 38.57 50 34.69"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardPackage);
export default __webpack_public_path__ + "static/media/STANDARD-PACKAGE.418efe15aa4eb5b7de9ed1cd98e1ed4d.svg";
export { ForwardRef as ReactComponent };